<template>
  <v-dialog
    eager
    width="500"
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-row justify="space-around">
          <v-col cols="12">
            <v-text-field
              outlined
              disabled
              v-model="currentItem.elevatorName"
              :label="$t('display/logs:email-log.elevator-name')"
            />
            <v-text-field
              outlined
              disabled
              v-model="currentItem.msgTime"
              :label="$t('display/logs:log-file.message-time')"
            />
            <v-text-field
              outlined
              disabled
              v-model="currentItem.fileSize"
              :label="$t('display/logs:log-file.file-size')"
            />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="downloadFile"
        >
          {{ $t('display/logs:log-file.download') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import LogsService from '@/modules/display/services/logs-service';

export default {
  name: "DetailInfoWindow",
  data() {
    return {
      currentItem: {
        elevatorName: '',
        msgTime: ''
      },
      dialog: false
    }
  },
  methods: {
    initialization(item) {
      this.currentItem = item;
      this.dialog = true;
    },
    downloadFile() {
      LogsService.downloadFileLog(
        this.currentItem.id,
        (response) => {
          const blob = new Blob([response.data], {type: 'text/plain'});
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.currentItem.id + '.log';
          link.click();
          URL.revokeObjectURL(link.href);
        }
      )
    }
  }
}
</script>